import React from 'react'
import _ from 'common-tools/LodashHelper'
import Loadable from 'react-loadable'
const uuidv4 = require('uuid/v4')

// componentName must be the export component of the passed in import module
export function BuildDelayedComponent (componentName, loader) {
  return Loadable({
    loader: loader,
    delay: 0,  // show loading indicator immediately (no blank-screen flash)
    loading: (props) => {
      if (props.error) {
        console.log(props.error)
        return <div className="startup">
          <img className="startup-animation" src="/Content/images/logoloading.png" />
          <div>Error Loading Component</div>
          <div>{props.error.message || String(props.error)}</div>
          <button onClick={ props.retry }>Retry</button>
        </div>
      } else if (props.timedOut) {
        return <div className="startup">
          <img className="startup-animation" src="/Content/images/logoloading.png" />
          <div>Taking a long time...</div>
          <button onClick={ props.retry }>Retry</button>
        </div>
      } else if (props.pastDelay) {
        return <div className="startup">
          <img className="startup-animation" src="/Content/images/logoloading.png" />
        </div>
      } else {
        return null
      }
    },
    render (loaded, props) {
      const Component = loaded[componentName]

      if (!Component) {
        console.log(`Could not find the component '${componentName}' in the requested BuildDelayedComponent`)
        return null
      }

      return <Component key={componentName} {...props}/>
    }
  })
}

export function BuildTransitionPath (uri, pathname, key = uuidv4(), maxSegments = 1) {
  let testUrl = pathname
  testUrl = _.replace(testUrl, uri, '')
  const testURLParts = testUrl.split('/')
  const path = `${key}-${_.join(_.take(_.filter(testURLParts, (v) => { return v !== '' }), maxSegments), '-')}`
  return path
}

export function TransitionPathWrapper (options) {
  let internalWrapper = (lopts) => {
    return (WrappedComponent) => {
      let opts = _.merge({
        key: undefined,
        maxSegments: 1
      }, lopts)

      if (!opts.key) {
        opts.key = uuidv4()
      }

      class TransitionPathInternal extends React.Component {
        ref = null

        getWrappedInstance () {
          return this.ref
        }

        render () {
          const { uri, location } = this.props

          const path = BuildTransitionPath(uri, location.pathname, opts.key, opts.maxSegments)

          return (
            <WrappedComponent ref={(c) => { this.ref = c }} {...this.props} TransitionPath={path} />
          )
        }
      }

      return TransitionPathInternal
    }
  }

  if (_.isFunction(options)) {
    return internalWrapper({})(options)
  }

  return internalWrapper(options)
}
